import { arrayOf, node, oneOfType, object, string, bool, func } from 'prop-types'
import Div from '../layout/Div'
import Buttons from '../elements/Buttons'
import { useEffect, useRef } from 'react'

const Modal = ({
  cssClass = '',
  children,
  isActive = false,
  closeCallback = () => { },
  closeAction = true
}) => {
  const scrollPosition = useRef(0)

  useEffect(() => {
    if (isActive) {
      scrollPosition.current = window.pageYOffset || document.documentElement.scrollTop
      document.body.style.overflow = 'hidden'
      document.querySelector('html').style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollPosition.current}px`
      document.querySelector('html').style.top = `-${scrollPosition.current}px`
      document.body.style.width = '100%'

      return () => {
        document.body.style.overflow = ''
        document.querySelector('html').style.overflow = ''
        document.body.style.position = ''
        document.body.style.top = ''
        document.querySelector('html').style.top = ''
        document.body.style.width = ''
        window.scrollTo(0, scrollPosition.current)
      }
    }
  }, [isActive])

  return (
    <Div cssClass={`${cssClass} modal ${isActive ? 'is-active' : ''}`}>
      <Div cssClass="modal-background"></Div>
      <Div cssClass="modal-content">
        {children}
      </Div>
      {closeAction && <Buttons buttons={{ cssClass: 'modal-close is-large', callback: closeCallback }} />}
    </Div>
  )
}

Modal.propTypes = {
  cssClass: string,
  closeAction: bool,
  closeCallback: func,
  children: oneOfType([arrayOf(node), string, object]),
  id: string,
  isActive: bool
}

export default Modal
